import debounce from 'lodash.debounce';

/* v8 ignore start */
const _ = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ {
  // @ts-expect-error ignore missing type definition
  constructor(callback: (...args) => void) {
    callback = debounce(callback, 20);
    super(callback);
  }
};
/* v8 ignore stop */
